import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import userService from './UserService';
import { Pager } from '../Pager';
import { FormGroup, Form, Input, Button } from 'reactstrap';
import { FaKey,FaSortAlphaDown,FaSortAlphaUp,FaEdit,FaTrash } from 'react-icons/fa';

export class UserList extends Component {
	constructor(props) {
		super(props);
		this.state = { users: [], page: 1, pageSize: 10, maxPages: 5, sortOrder: "Fname", searchString: "", loading: true };
	}

	componentDidMount() {
		this.populateUserData();
	}

	handlePageChange = (page) => {
		this.setState({ page: page }, () => this.populateUserData() );
	}

	handleHeaderClick = (event, header) => {
		event.preventDefault();

		let newSortOrder = this.state.sortOrder;

		switch (header) {
			case 'Fname': {
				newSortOrder = this.state.sortOrder === 'Fname' ? 'Fname_desc' : 'Fname';
				break;
			}
			case 'Lname': {
				newSortOrder = this.state.sortOrder === 'Lname' ? 'Lname_desc' : 'Lname';
				break;
			}
			case 'Email': {
				newSortOrder = this.state.sortOrder === 'Email' ? 'Email_desc' : 'Email';
				break;
			}
		}

		this.setState({ page: 1, sortOrder: newSortOrder }, () => this.populateUserData());
		return false;
	}

	handleInputChange = (event) => {
		const target = event.target;
		const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;

		this.setState({ [name]: value });
	}

	handleSearchFormSubmit = (event) => {
		event.preventDefault();
		this.setState({ page: 1 }, () => this.populateUserData());
		//this.populateUserData();
	}

	handleSearchFormReset = (event) => {
		event.preventDefault();
		this.setState({ page:1, searchString: "" }, () => this.populateUserData());
	}

	renderUsersTable() {
		const { users, totalUsers, sortOrder } = this.state;

		return (
			<div>
				<table className='table table-striped' aria-labelledby="tableLabel">
					<thead>
						<tr>
							<th>
								<a href="#" onClick={(e) => this.handleHeaderClick(e, 'Fname')} >
									First Name&nbsp;
									{sortOrder == 'Fname' && <FaSortAlphaDown /> }
									{sortOrder == 'Fname_desc' && <FaSortAlphaUp /> }
								</a>
							</th>
							<th>
								<a href="#" onClick={(e) => this.handleHeaderClick(e, 'Lname')} >
									Last Name&nbsp;
									{sortOrder == 'Lname' && <FaSortAlphaDown /> }
									{sortOrder == 'Lname_desc' && <FaSortAlphaUp /> }
								</a>
							</th>
							<th>
								<a href="#" onClick={(e) => this.handleHeaderClick(e, 'Email')} >
									Email&nbsp;
									{sortOrder == 'Email' && <FaSortAlphaDown /> }
									{sortOrder == 'Email_desc' && <FaSortAlphaUp /> }
								</a>
							</th>
							<th />
							<th />
							<th />
						</tr>
					</thead>
					<tbody>
						{users.map(user =>
							<tr key={user.id}>
								
								<td>{user.firstname}</td>
								<td>{user.surname}</td>
								<td>{user.email}</td>
								<td><Link to={'/users/delete/' + user.id}><FaTrash /></Link></td>
								<td><Link to={'/users/edit/' + user.id}><FaEdit /></Link></td>
								<td><Link to={'/users/password-change/' + user.id}><FaKey /></Link></td>
							</tr>
						)}
					</tbody>
				</table>
				<Pager totalItems={totalUsers} page={this.state.page} pageSize={this.state.pageSize} maxPages={this.state.maxPages} handlePageChange={this.handlePageChange} />
			</div>
		);
	}

	render() {
		let contents = this.state.loading
			? <p><em>Loading...</em></p>
			: this.renderUsersTable();

		return (
			<div>
				<h1 id="tableLabel">Users</h1>
				<Link to='/users/add/'>Add User</Link>
				<Form inline onSubmit={this.handleSearchFormSubmit}>
					<FormGroup>
						<Input type="text" name="searchString" value={this.state.searchString} onChange={this.handleInputChange} placeholder="Last Name or Email" />
					</FormGroup>&nbsp;
					<Button>Search</Button>&nbsp;
					<Button onClick={this.handleSearchFormReset}>Reset</Button>
				</Form><br/>
				{contents}
			</div>
		);
	}

	async populateUserData() {
		try {

			const data = await userService.getUsers(this.state.page, this.state.pageSize, this.state.sortOrder, this.state.searchString);
			this.setState({ totalUsers: data.totalUsers, users: data.users, loading: false });
		}
		catch (error) {
			// Handle error
		}
	}
}